{
  "languages": {
    "en": "English",
    "it": "Italiano"
  },
  "labels": {
    "measures": "Misure",
    "kpis": "KPIs",
    "cancel": "Annulla",
    "update": "Aggiorna",
    "continue": "Continua",
    "confirm": "Conferma",
    "clear-all": "Cancella tutto",
    "title-allowed": "Valori Consentiti",
    "title-target": "Valore Target",
    "value": "Valore",
    "unit-measure": "Unità di misura",
    "required": "Campo richiesto",
    "selected": "Selezionati",
    "delete-all": "Rimuovi tutti",
    "delete": "Rimuovi",
    "empty": "",
    "kpitype-quantitative": "Quantitativo",
    "kpitype-qualitative": "Qualitativo",
    "search": "Cerca",
    "latitude": "Latitudine",
    "longitude": "Longitudine",
    "description": "Descrizione",
    "save": "Salva",
    "close": "Close",
    "back": "Indietro",
    "title-unit-measure": "Unità di Misura"
  },
  "strings": {
    "select-location": "Imposta la posizione del KPI",
    "reset-location": "Cancella la posizione del PKI",
    "select-location-info": "Seleziona o immetti le coordinate del luogo assegnato a questo Kpi",
    "arrow-button-hint": "Seleziona una risorsa cliccando la freccia alla sua destra",
    "selected-items-hint": "Risorse utili ai calcoli delle formule",
    "kpi-description": "Descrizione del Kpi",
    "no-selected-items": "Nessuna risorsa selezionata",
    "no-kpis-items": "Nessun KPI disponibile",
    "no-measures-items": "Nessuna misura disponibile",
    "target-hint": "Definisce il valore target ideale per il KPI",
    "allowed-hint": "Definisce i valori consentiti per il KPI qualitativo",
    "allowed-info": "Prima posizione significa un peso maggiore per il KPI, l'ultima posizione un peso minore",
    "confirm-title": "Conferma",
    "placeholder": "Inserisci elemento",
    "confirm-message": "Sei sicuro di voler rimuovere l'elemento '{name}'?",
    "kpi-type-title": "Tipo di valori",
    "kpi-type-hint": "Seleziona il tipo di valori per il KPI manuale",
    "invalid-value": "Inserire un valore valido",
    "duplicate": "Elemento già presente nella lista",
    "max-reached": "Numero massimo di elementi raggiunto ({count})",
    "added-success": "Elemento aggiunto con successo",
    "removed-success": "Elemento '{name}' rimosso",
    "kpi-type": "Tipo KPI",
    "title-kpi-values": "Valori KPI",
    "values-definition-hint": "Aggiungi valori per il calcolo KPI manuale",
    "values-type-change-confirm": "Se modifichi il tipo di valori, tutti i valori inseriti ed eventualmente la lista di valori consenti, verranno eliminati.",
    "add-value": "Aggiungi valore",
    "close": "Chiudi",
    "number-hint": "Inserire un valore numerico",
    "cleared-all": "Tutti gli elementi cancellati",
    "values-clear-all-confirm": "Confermi di voler cancellare tutti i valori inseriti?",
    "kpitype-quantitative-tooltip": "Quantitativo: valori numerici misurabili; richiede Unità di misura",
    "kpitype-qualitative-tooltip": "Qualitativo: valori descrittivi o categoriali; non richiede Unità di misura",
    "unit-measure-hint": "Definisci l'unità di misura del KPI"
  },
  "measures": {
    "NONE": "Nessuna",
    "METER": "Metri",
    "KILOMETER": "Chilometri",
    "CENTIMETER": "Centimetri",
    "MILLIMETER": "Millimetri",
    "MICROMETER": "Micrometri",
    "NANOMETER": "Nanometri",
    "MILE": "Miglia",
    "YARD": "Iarde",
    "FOOT": "Piedi",
    "INCH": "Pollici",
    "KILOGRAM": "Chilogrammi",
    "GRAM": "Grammi",
    "MILLIGRAM": "Milligrammi",
    "MICROGRAM": "Microgrammi",
    "TONNE": "Tonnellate",
    "POUND": "Libbre",
    "OUNCE": "Once",
    "SECOND": "Secondi",
    "MILLISECOND": "Millisecondi",
    "MICROSECOND": "Microsecondi",
    "NANOSECOND": "Nanosecondi",
    "MINUTE": "Minuti",
    "HOUR": "Ore",
    "DAY": "Giorni",
    "WEEK": "Settimane",
    "MONTH": "Mesi",
    "YEAR": "Anni",
    "LITER": "Litri",
    "MILLILITER": "Millilitri",
    "CUBIC_METER": "Metri Cubi",
    "CUBIC_CENTIMETER": "Centimetri Cubi",
    "GALLON": "Galloni",
    "QUART": "Quarti",
    "PINT": "Pinte",
    "CUP": "Tazze",
    "FLUID_OUNCE": "Once Fluide",
    "SQUARE_METER": "Metri Quadrati",
    "SQUARE_KILOMETER": "Chilometri Quadrati",
    "SQUARE_CENTIMETER": "Centimetri Quadrati",
    "SQUARE_MILLIMETER": "Millimetri Quadrati",
    "HECTARE": "Ettari",
    "ACRE": "Acri",
    "METER_PER_SECOND": "Metri Al Secondo",
    "KILOMETER_PER_HOUR": "Chilometri All'ora",
    "MILE_PER_HOUR": "Miglia All'ora",
    "CELSIUS": "Celsius",
    "FAHRENHEIT": "Fahrenheit",
    "KELVIN": "Kelvin",
    "JOULE": "Joule",
    "KILOJOULE": "Chilojoule",
    "CALORIE": "Calorie",
    "KILOCALORIE": "Chilocalorie",
    "WATT_HOUR": "Watt Ore",
    "KILOWATT_HOUR": "Chilowatt Ore",
    "PASCAL": "Pascal",
    "KILOPASCAL": "Chilopascal",
    "BAR": "Bar",
    "ATMOSPHERE": "Atmosfere",
    "TORR": "Torr",
    "KILOGRAM_PER_CUBIC_METER": "Chilogrammi Al Metro Cubo",
    "GRAM_PER_CUBIC_CENTIMETER": "Grammi Al Centimetro Cubo",
    "HERTZ": "Hertz",
    "KILOHERTZ": "Chilohertz",
    "MEGAHERTZ": "Megahertz",
    "GIGAHERTZ": "Gigahertz"
  }
}
